import { createGlobalStyle } from 'styled-components';

import { fontFaces, paletteCssVariables } from 'client-ribbons-base/styles/baseStylesGenerators';
import { theme } from 'client-ribbons-base/styles/theme';

/** @deprecated use design-system-theme-brand2026customer styles instead */
export const FontFaces = createGlobalStyle`
  ${fontFaces(theme)};
`;

/** @deprecated use design-system-theme-brand2026customer styles instead */
export const Palette = createGlobalStyle`
  ${paletteCssVariables};
`;
